<template>
  <div>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else-if="error">
      <h1> {{ errorMessage }} </h1>
    </div>
    <div v-else>
      <div class='col l4 m4 s12'>
        <p><b>Type of Purchase</b></p>
        <select>
          <option value=''>Type of Purchase</option>
          <option value=''>School Direct Purchase</option>
          <option value=''>School Request through Dept. of Tech</option>
        </select>
      </div>

      <div class='col l4 m4 s12'>
        <p><b>Grade Level</b></p>
        <select>
          <option value=''>Grade Level</option>
          <option value=''>K-2</option>
          <option value=''>3-5</option>
          <option value=''>6-8</option>
          <option value=''>9-12</option>
        </select>
      </div>

      <div class='col l4 m4 s12'>
        <p><b>Category</b></p>
        <select @change="categorySelected($event)">
          <option value=''> Category </option>
          <option v-for="category in categories" :key="'category-' + category.ID" :value="category.ID" > {{ category.Title }} </option>
        </select>
      </div>
      <div class='flex-card-container'>
        <div class='flex-card' v-for="product in filteredProducts" :key="'product-' + product.ID">
          <Product 
            :title="product.Title" 
            :cost="product.UnitCost" 
            :description="product.ItemDetail"
            :category="product.CategoryId"
            :infoLink="product.ProductLink"
            :purchaseLink="product.Order_x0020_Now.Url"
          />
        </div>
      </div>


    </div>

    
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import Product from '@/components/Product.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

export default {
  name: 'Catalog',
  components: {
    Product,
    LoadingSpinner
  },
  data: () => {
    return {
      categories: [],
      products: [],
      loading: true,
      error: false,
      errorMessage: '',
      selectedCategory: null
    }
  },
  methods: {
    categorySelected (event) {
      
      this.selectedCategory = event.target.value
    }
  },
  computed: {
    filteredProducts: function () {
      if(this.selectedCategory != null && this.selectedCategory != '') {
        return this.products.filter((elem) => {
          return elem.CategoryId == this.selectedCategory
        })
      }
      else {
        return this.products
      }
    }
  },
  mounted () {
    axios.get('data.json')
         .then(response => {
           console.log(response)
           this.categories = response.data.categories
           this.products = response.data.products
           setTimeout(() => { this.loading = false}, 500)
         })
         .catch(error => {
           console.log(error)
           this.error = true
           this.loading = false
           this.errorMessage = error
         })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
